import { type SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    style={{ overflow: 'visible', ...props.style }}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.5 2.5l15 15M7.5 7.5c-1.5 1.5-2.5 3.5-2.5 5s1 3.5 2.5 5c4.5 0 7.5-5 7.5-5s-1.5-2.5-3.5-4M12.5 12.5c-1.5-1.5-2.5-3.5-2.5-5s1-3.5 2.5-5c-4.5 0-7.5 5-7.5 5s1.5 2.5 3.5 4"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10 7.5c.5.5.5 1.5 0 2.5"
    />
  </svg>
);

export { SvgComponent as EyeOffIcon };

